import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import { withShadow } from 'ui/styles';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  background-color: #fff;
  ${withShadow};
  border-radius: 4px;
`;

const Header = styled.div`
  flex-grow: 0;
  flex-shrink: 0;
  background-color: ${p => p.theme.colors.theme};
  color: #fff;
  padding: 0.5em 1em;
  font-size: 1rem;
  font-weight: ${p => p.theme.fontWeight.bolder};
  border-radius: 4px 4px 0 0;
`;

const Content = styled.div`
  flex-grow: 1;
  padding: 20px;
  overflow: auto;
`;

const Panel = ({ title, children }) =>
  <Wrapper>
    <Header>{typeof title === 'function' ? title() : title}</Header>
    <Content>{children}</Content>
  </Wrapper>;
Panel.propTypes = {
  title: PropTypes.oneOfType([PropTypes.func, PropTypes.string, PropTypes.node]),
  children: PropTypes.node,
};

export default Panel;
